import { render, staticRenderFns } from "./FooterBtn.vue?vue&type=template&id=07cd64c5&scoped=true&"
import script from "./FooterBtn.vue?vue&type=script&lang=js&"
export * from "./FooterBtn.vue?vue&type=script&lang=js&"
import style0 from "./FooterBtn.vue?vue&type=style&index=0&id=07cd64c5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cd64c5",
  null
  
)

export default component.exports